import {
  EDITOR_TOGGLE_DEBUG_MODE_BEGIN,
  EDITOR_TOGGLE_DEBUG_MODE_SUCCESS,
  EDITOR_TOGGLE_DEBUG_MODE_FAILURE,
  EDITOR_TOGGLE_DEBUG_MODE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function toggleDebugMode(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_TOGGLE_DEBUG_MODE_BEGIN,
    });
    const { projectId, version } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/debug`,
        args.data,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_TOGGLE_DEBUG_MODE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_TOGGLE_DEBUG_MODE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissToggleDebugModeError() {
  return {
    type: EDITOR_TOGGLE_DEBUG_MODE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_TOGGLE_DEBUG_MODE_BEGIN:
      return {
        ...state,
        toggleDebugModePending: true,
        toggleDebugModeError: null,
      };

    case EDITOR_TOGGLE_DEBUG_MODE_SUCCESS:
      return {
        ...state,
        toggleDebugModePending: false,
        toggleDebugModeError: null,
        project: action.data,
      };

    case EDITOR_TOGGLE_DEBUG_MODE_FAILURE:
      return {
        ...state,
        toggleDebugModePending: false,
        toggleDebugModeError: action.data.error,
      };

    case EDITOR_TOGGLE_DEBUG_MODE_DISMISS_ERROR:
      return {
        ...state,
        toggleDebugModeError: null,
      };

    default:
      return state;
  }
}
